import gql from 'graphql-tag'

export const GET_VEHICLE = gql`
  query Vehicles($filter: GetVehiclesFilter) {
    vehicles(filter: $filter) {
      isSuccessful
      message
      vehicles {
        id
        door1
        door2
        driver1Id
        driver1 {
          fullname
        }
        odometer
        status
        imei
        licensePlate
        hullNo
        vehicleType {
          manufacturer
          model
          type
          category
          icon
        }
        hourmeter
        vehicleStatus {
          latitude
          longitude
          motionStatus
          lastPacket
        }
        company {
          name
          id
        }
        vehicleTypeId
        vehicle2Vgroup {
          vgroup {
            name
          }
        }
      }
    }
  }
`

export const GET_VEHICLES_PAGINATED = gql`
  query VehiclesPaginated($filter: GetVehiclesFilter) {
    vehiclesPaginated(filter: $filter) {
      isSuccessful
      message
      vehiclesPaginated {
        data {
          id
          companyId
          driver1Id
          driver2Id
          garageId
          tonnage
          volume
          fuelEfficiency
          fuelCapacity
          odometer
          refrigerator
          hourmeter
          status
          imei
          licensePlate
          vehicleTypeId
          sourceMode
          vehicleType {
            vehicleTypeId
            companyId
            isActive
            manufacturer
            model
            type
            category
            transmissionType
            fuelType {
              fuelTypeId
              name
              category
            }
            tonnage
            volume
            fuelEfficiency
            hasRelation
            icon
          }
          thermoType
          boxType
          chassisNumber
          machineNumber
          carrosserie
          year
          hullNo
          door1
          door2
          company {
            id
            name
          }
          driver1 {
            userId
            fullname

            email
          }
          driver2 {
            userId
            fullname
            email
          }
          garage {
            geofenceId
            companyId
            customerId
            fenceName
            type
            polyData
            circData
            address
            addressDetail
            province
            city
            postalCode
            category
            contactName
            phoneNo
            isGarage
            isServiceLoc
            isBillingAddr
            isDepot
            isAlert
            serviceStart
            serviceEnd
            breakStart
            breakEnd
            serviceLocType
            customerName
            hasRelation
          }
          device {
            imei
            identifier
            companyId
            vehicleId
            phoneNo
            ip
            port
            deviceCode
            deviceName
            vendorType
            portKernel
            activeOn
            status
            domain
            database
            username
            password
          }
          vehicleDocs {
            licensePlate
            vehicleId
            docType
            docNumber
            validUntil
            status
          }
          idleDuration
          parkingDuration
          vehicle2Vgroup {
            vgroup {
              name
              id
            }
          }
          identificationSupport {
            rfid
            face
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
      status
    }
  }
`

export const GET_VEHICLE_ID = gql`
  query Vehicle($filter: GetVehicleFilter!) {
    vehicle(filter: $filter) {
      isSuccessful
      message
      vehicle {
        id
        thirdPartyId
        year
        licensePlate
        hullNo
        imei
        vehicleDocs {
          docType
          docNumber
          validUntil
        }
        hourmeter
        refrigerator
        sourceMode
        odometer
        machineNumber
        garage {
          fenceName
          geofenceId
        }
        chassisNumber
        carrosserie
        driver1 {
          userId
          isDriver
          fullname
          email
        }
        driver2 {
          userId
          isDriver
          fullname
          email
        }
        status
        thermoType
        boxType
        device {
          imei
          identifier
          vendorType
          deviceName
          phoneNo
        }
        fuelEfficiency
        vehicleType {
          vehicleTypeId
          companyId
          isActive
          manufacturer
          model
          type
          category
          transmissionType
          fuelType {
            fuelTypeId
            name
            category
          }
          tonnage
          volume
          fuelEfficiency
          hasRelation
          icon
        }
        boxTypeObject {
          boxTypeId
          companyid
          name
          volumeCapacity
          weightCapacity
        }
        vehicle2Vgroup {
          vgroup {
            name
            id
          }
        }
        sensor {
          sensorCode
          statusBool
        }
        operationalNotes
        idleDuration
        parkingDuration
        identification {
          driverId
          fullname
          face {
            status
            data
          }
          rfid {
            status
            data
          }
        }
        vehicle2Regions {
          region {
            regionId
            name
          }
        }  
      }
    }
  }
`
export const GET_VEHICLE_AUDIT_LOG = gql`
  query VehicleAuditLogs($filter: VehicleAuditLogInput!) {
    vehicleAuditLogs(filter: $filter) {
      vehicleAuditLogs {
        time
        action
        detail
        user
        object
        oldData
        newData
        actionType
      }
      isSuccessful
      message
    }
  }
`

export const VEHICLE_MUTATION_CREATE = gql`
  mutation CreateVehicle($input: CreateVehicleInput!) {
    createVehicle(input: $input) {
      isSuccessful
      message
      vehicle {
        id
      }
    }
  }
`

export const VEHICLE_MUTATION_UPDATE = gql`
  mutation UpdateVehicle($input: UpdateVehicleInput!) {
    updateVehicle(input: $input) {
      isSuccessful
      message
      vehicle {
        id
      }
    }
  }
`

export const VEHICLE_MUTATION_DELETE = gql`
  mutation DeleteVehicle($input: DeleteVehicleInput!) {
    deleteVehicle(input: $input) {
      isSuccessful
      message
      vehicle {
        id
        licensePlate
      }
    }
  }
`

export const UPDATE_VEHICLES = gql`
  mutation UpdateVehicles($input: UpdateVehiclesInput!) {
    updateVehicles(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`

export const GET_VEHICLE_FILTER_ALL = gql`
  query Vehicles($filter: GetVehiclesFilter) {
    vehicles(filter: $filter) {
      isSuccessful
      message
      vehicles {
        id
        door1
        door2
        licensePlate
        status
        vehicleType {
          manufacturer
          model
          type
          category
          vehicleTypeId
        }
        vehicle2Vgroup {
          vgroup {
            id
            name
          }
        }
      }
    }
  }
`

export const GET_VEHICLE_FILTER = gql`
  query VehiclesFilter($filter: VehiclePaginatedFilter) {
    vehiclesFilter(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehiclesFilterPaginated {
        data {
          id
          licensePlate
          vehicleTypeId
          status
          vehicleType {
            manufacturer
            model
            type
            category
          }
          imei
          vehicle2Vgroup {
            vgroup {
              name
            }
          }
        }
        ids
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_VEHICLE_TYPES = gql`
  query VehicleTypes($filter: GetVehicleTypesFilter) {
    vehicleTypes(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleTypes {
        ids
        data {
          vehicleTypeId
          manufacturer
          model
          type
          category
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const GET_VEHICLE_GROUPS = gql`
  query Vgroups($filter: GetVgroupsInput) {
    vgroups(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vgroups {
        id
        name
      }
    }
  }
`
